import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';

const ContextHelp = ({ helpLink }) => (
  <IconButton
    component="a"
    href={`${process.env.REACT_APP_KB_URL}${helpLink}`}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Context help"
    size="small"
  >
    <HelpIcon fontSize="small" />
  </IconButton>
);

ContextHelp.propTypes = {
  helpLink: PropTypes.string.isRequired,
};

export default ContextHelp;
